// tr strings for messages/upsell.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const upsell: Dict = {
  "upsell.creator.train.title": "Creator ile eğitmeye başla",
  "upsell.creator.train.lead": "Ses eğitme Creator planında var.",
  "upsell.creator.train.tick1": "Sınırsız ses eğit",
  "upsell.creator.train.tick2": "Marble Run videoları, ayda 50 jeton",
  "upsell.creator.train.tick3": "Planındaki her şey kalır",
  "upsell.creator.train.cta": "Yükselt ve eğitmeye başla",

  "upsell.creator.export.title": "1080p dışa aktar",
  "upsell.creator.export.lead":
    "Creator videolarını tam 1080p kalitede dışa aktarır.",
  "upsell.creator.export.tick1": "1080p dışa aktarma",
  "upsell.creator.export.tick2": "Marble Run videoları, ayda 50 jeton",
  "upsell.creator.export.tick3": "Sınırsız ses eğit",
  "upsell.creator.export.cta": "Yükselt ve 1080p dışa aktar",

  "upsell.creator.marble.title": "Marble Run, Creator planında",
  "upsell.creator.marble.lead":
    "Cover'larını TikTok ve Reels'e hazır Marble Run videolarına dönüştür.",
  "upsell.creator.marble.tick1": "Her ay 50 Marble Run jetonu",
  "upsell.creator.marble.tick2": "Stüdyodan 1080p dışa aktarma",
  "upsell.creator.marble.tick3": "Sınırsız ses eğit",
  "upsell.creator.marble.cta": "Yükselt ve Marble Run yap",

  "upsell.creator.video.title": "Videolar Creator planında",
  "upsell.creator.video.lead":
    "Cover'larını TikTok ve Reels için paylaşılabilir videolara dönüştür.",
  "upsell.creator.video.tick1": "Paylaşılabilir videolar, ayda 50 jeton",
  "upsell.creator.video.tick2": "Stüdyodan 1080p dışa aktarma",
  "upsell.creator.video.tick3": "Sınırsız ses eğit",
  "upsell.creator.video.cta": "Yükselt ve videomu yap",

  "upsell.creator.samplesOne": "Vokallerin hazır: {files} dosya, {duration}. ",
  "upsell.creator.samplesMany": "Vokallerin hazır: {files} dosya, {duration}. ",
  // Rendered as "<nothing> <toPayToday>" or "<price> <today>".
  "upsell.creator.nothing": "Ödeme yok",
  "upsell.creator.today": "bugün",
  "upsell.creator.toPayToday": "bugün",
  "upsell.creator.thenMonth": "sonra ayda {price}",
  "upsell.creator.credited":
    "Bu ayın kalan kısmı hesabına yansıtılır. İstediğin zaman iptal et.",
  "upsell.creator.priceError":
    "Yükseltme fiyatını yükleyemedik. İstediğin zaman Ayarlar'dan yükseltebilirsin.",
  "upsell.creator.upgrading": "Yükseltiliyor...",
  "upsell.creator.notNow": "Şimdi değil",
  "upsell.creator.payFailed":
    "Ödeme gerçekleşmedi, bu yüzden hiçbir şey değişmedi. Ayarlar'dan kartını kontrol edip tekrar dene.",

  "upsell.coins.title": "Pro Jeton al",
  "upsell.coins.subtitle": "Her jeton paylaşılabilir bir video oluşturur",
  "upsell.coins.coinAlt": "Pro Jeton",
  "upsell.coins.useMarble": "Marble Run videoları",
  "upsell.coins.useLyric": "Sözlü videolar",
  "upsell.coins.useTemplates": "Tüm video şablonları",
  "upsell.coins.bestValue": "EN AVANTAJLI",
  "upsell.coins.mostCoins": "EN ÇOK JETON",
  "upsell.coins.proCoins": "Pro jeton",
  "upsell.coins.each": "tanesi {price}",
  "upsell.coins.purchase": "Satın al",
  "upsell.coins.footer":
    "Pro Jetonlar anında eklenir ve süresi dolmaz. 1 jeton = 1 video.",
};

export default upsell;
